import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  showMap: false,
  selectedBusiness: [],
  selectedFarms: [],
  siteWithNoCrops: false,
  chemicalFreeCropSites: false,
  search: "",
  debouncedSearch: "",
  isFilterApplied: false,
};

const siteFilterSlice = createSlice({
  name: "siteFilter",
  initialState,
  reducers: {
    setShowMap: (state, action) => {
      state.showMap = action.payload;
    },
    setSelectedBusiness: (state, action) => {
      state.selectedBusiness = action.payload;
    },
    setSelectedFarms: (state, action) => {
      state.selectedFarms = action.payload;
    },
    setSiteWithNoCrops: (state, action) => {
      state.siteWithNoCrops = action.payload;
    },
    setChemicalFreeCropSites: (state, action) => {
      state.chemicalFreeCropSites = action.payload;
    },
    setSearch: (state, action) => {
      state.search = action.payload;
    },
    setDebouncedSearch: (state, action) => {
      state.debouncedSearch = action.payload;
    },
    setIsFilterApplied: (state, action) => {
      state.isFilterApplied = action.payload;
    },
    resetSiteDrawerFilters: (state) => {
      state.selectedBusiness = [];
      state.selectedFarms = [];
      state.siteWithNoCrops = false;
      state.chemicalFreeCropSites = false;
      state.isFilterApplied = false;
    },
    resetSiteFilters: (state) => {
      state.showMap = false;
      state.selectedBusiness = [];
      state.selectedFarms = [];
      state.siteWithNoCrops = false;
      state.chemicalFreeCropSites = false;
      state.search = "";
      state.debouncedSearch = "";
      state.isFilterApplied = false;
    },
  },
});

export const {
  setShowMap,
  setSelectedBusiness,
  setSelectedFarms,
  setSiteWithNoCrops,
  setChemicalFreeCropSites,
  setSearch,
  setDebouncedSearch,
  setIsFilterApplied,
  resetSiteDrawerFilters,
  resetSiteFilters,
} = siteFilterSlice.actions;
export default siteFilterSlice.reducer;
